import React from 'react';
import { lazyWithPreload } from './lazyWithPreload';
import NotFoundPage from './pages/NotFoundPage';
import GonePage from './pages/GonePage';
import ServerErrorPage from './pages/ServerErrorPage';
import { GONE_SENTINEL_PATH, SERVER_ERROR_SENTINEL_PATH } from './ssrErrorPaths';

const IndexComponent = lazyWithPreload(() => import('./IndexComponent'));
const GazetePage = lazyWithPreload(() => import('./GazetePage'));
const YearPageComponent = lazyWithPreload(() => import('./pages/YearPageComponent'));
const YearEtiketPageComponent = lazyWithPreload(() => import('./pages/YearEtiketPageComponent'));
const GazeteSayisi = lazyWithPreload(() => import('./GazeteSayisi'));
const GazeteSayfasi = lazyWithPreload(() => import('./GazeteSayfasi'));
const KupurPageComponent = lazyWithPreload(() => import('./KupurPageComponent'));
const AraPageComponent = lazyWithPreload(() => import('./AraPageComponent'));
const BlockAraPage = lazyWithPreload(() => import('./pages/BlockAraPage'));
const TarihComponent = lazyWithPreload(() => import('./pages/TarihComponent'));
const PrivacyPage = lazyWithPreload(() => import('./PrivacyPage'));
const CollectionPage = lazyWithPreload(() => import('./pages/Collection'));
const CollectionsPage = lazyWithPreload(() => import('./pages/CollectionsPage') as any);
const EtiketPage = lazyWithPreload(() => import('./pages/Etiket'));
const KupurKesPageComponent = lazyWithPreload(() => import('./KupurKesPageComponent'));
const KupurOnerPage = lazyWithPreload(() => import('./KupurOnerPage'));
const AccountPage = lazyWithPreload(() => import('./AccountPage'));
const ResetPasswordPage = lazyWithPreload(() => import('./pages/ResetPasswordPage'));
const ArastirmalarPage = lazyWithPreload(() => import('./pages/ArastirmalarPage'));
const ArastirmaPage = lazyWithPreload(() => import('./pages/ArastirmaPage'));
const GununMansetleriPage = lazyWithPreload(() => import('./pages/GununMansetleriPage'));
const GununMansetiGazetePage = lazyWithPreload(() => import('./pages/GununMansetiGazetePage'));
const NewsArticlePage = lazyWithPreload(() => import('./pages/NewsArticlePage'));
const SubscriptionPage = lazyWithPreload(() => import('./pages/SubscriptionPage'));
const SubscriptionSuccessPage = lazyWithPreload(() => import('./pages/SubscriptionSuccessPage') as any);
const AiTarihciPage = lazyWithPreload(() => import('./pages/AiTarihciPage'));
const TarihteBugunPage = lazyWithPreload(() => import('./pages/TarihteBugunPage'));
const AdminUsersPage = lazyWithPreload(() => import('./pages/AdminUsersPage'));

/** Lazy component with optional preload for SSR */
type LazyComponent = React.LazyExoticComponent<React.ComponentType<any>> & {
  preload?: () => Promise<unknown>;
};

/** Route config for react-router-config (path optional for catch-all) */
export interface RouteConfig {
  path?: string;
  exact?: boolean;
  component: React.ComponentType<any> | LazyComponent;
}

const NotFound: React.FC = () => {
  console.debug('[NotFound route] Route not found');
  return <NotFoundPage />;
};

const Routes: RouteConfig[] = [
  {
    path: '/',
    exact: true,
    component: IndexComponent,
  },
  {
    path: '/gazete/:gazete/:tarih/:sayfa',
    exact: true,
    component: GazeteSayfasi,
  },
  {
    path: '/gazete/:gazete/:page?',
    component: GazetePage,
  },
  {
    path: '/gazeteSayisi/:gazete/:tarih',
    component: GazeteSayisi,
  },
  {
    path: '/kupurKes/:gazete/:tarih/:sayfa',
    component: KupurKesPageComponent,
  },
  {
    path: '/kupurOner/:gazete?/:tarih?/:sayfa?',
    component: KupurOnerPage,
  },
  {
    path: '/kupur/:id',
    component: KupurPageComponent,
  },
  {
    path: '/ara/:query?/:page?',
    component: AraPageComponent,
  },
  {
    path: '/blockAra/:query?/:page?',
    component: BlockAraPage,
  },
  {
    path: '/etiket/:etiket?/:page?',
    component: EtiketPage,
  },
  {
    path: '/tarih/:tarih',
    component: TarihComponent,
  },
  {
    path: '/yil/:yil/etiket/:tag/:page?',
    component: YearEtiketPageComponent,
  },
  {
    path: '/yil/:yil',
    component: YearPageComponent,
  },
  {
    path: '/collections',
    exact: true,
    component: CollectionsPage,
  },
  {
    path: '/collection/:id',
    component: CollectionPage,
  },
  {
    path: '/arastirmalar',
    exact: true,
    component: ArastirmalarPage,
  },
  {
    path: '/arastirma/:slug',
    component: ArastirmaPage,
  },
  {
    path: '/tarihte-bugun',
    exact: true,
    component: TarihteBugunPage,
  },
  {
    path: '/gun/:monthDay(\\d{2}-\\d{2})',
    exact: true,
    component: TarihteBugunPage,
  },
  {
    path: '/gunun-mansetleri',
    exact: true,
    component: GununMansetleriPage,
  },
  {
    path: '/gunun-manseti/:gazete',
    component: GununMansetiGazetePage,
  },
  {
    path: '/haber/:id',
    component: NewsArticlePage,
  },
  {
    path: '/account',
    component: AccountPage,
  },
  {
    path: '/admin/users',
    exact: true,
    component: AdminUsersPage,
  },
  {
    path: '/privacy',
    component: PrivacyPage,
  },
  {
    path: '/subscription',
    component: SubscriptionPage,
  },
  {
    path: '/ai-tarihci',
    exact: true,
    component: AiTarihciPage,
  },
  {
    path: '/subscription-success',
    component: SubscriptionSuccessPage,
  },
  {
    path: '/reset-password',
    component: ResetPasswordPage,
    exact: true,
  },
  {
    path: SERVER_ERROR_SENTINEL_PATH,
    exact: true,
    component: ServerErrorPage,
  },
  {
    path: GONE_SENTINEL_PATH,
    exact: true,
    component: GonePage,
  },
  {
    component: NotFound,
  },
];

export default Routes;
